import { Typography } from "@mui/material"

const LoadingPage = () => {
  return (
    <div className="w-full h-full flex justify-center items-center gap-4">
      <Typography>Cargando...</Typography>
    </div>
  )
}

export default LoadingPage
